<template>
    <div>
        <h4 class="text-center">Valor total:</h4>
        <div class="payment-total">
            <h4>
                R$ {{ totalToShow }}
            </h4>
            <template v-if="totalInCash > 399.90">
                <p v-if="getMethod === 'credit-paypal'">em até 3x sem juros</p>
                <p v-if="getMethod === 'credit-cielo'">à vista ou em até {{ maxParcels.length }}x + taxas</p>
                <div class="div-plots" v-if="getMethod === 'credit-cielo'">
                    <label for="plots">
                        PARCELE SUA COMPRA
                    </label>

                    <parcels :max-parcels="maxParcels"/>
                </div>
            </template>
            <input v-else type="hidden" name="parcels" value="1">

            <input type="hidden" name="interest_rates" :value="interestRates">
        </div>
        <button v-if="getMethod !== 'credit-paypal'"
                type="submit"
                @click.prevent="handlePaymentBeforeSubmit()"
                class="btn btn-payment-confirmation border-6">
            Confirmar Compra
        </button>
    </div>
</template>

<script>
    export default {
        name: "total-payment",

        props: {
            totalUrl: String,
        },

        computed: {
            getMethod() {
                return this.$store.getters['getMethod'];
            },

            getCardBrand() {
                return this.$store.getters['getCardBrand'];
            },

            totalToShow() {
                return (this.selectedParcel === 1) ? this.totalInCashFormatted : this.total;
            }
        },

        mounted() {
            this.getParcelsForCurrentTotal();
            this.$root.$on('updateTotals', (payload) => {
                this.freightValue = payload;
            });

            this.$root.$on('update-show-total', (payload) => {
                this.selectedParcel = payload;
            });
        },

        data() {
            return {
                total: '-',
                rawTotal: 0,
                maxParcels: {},
                totalInCash: 0,
                freightValue: 0,
                interestRates: 0,
                selectedParcel: 1,
                totalInCashFormatted: 0,
            }
        },

        watch: {
            freightValue() {
                this.getParcelsForCurrentTotal();
            },

            getCardBrand() {
                this.getParcelsForCurrentTotal();
            },

            getMethod() {
                this.getParcelsForCurrentTotal();
            }
        },

        methods: {
            getParcelsForCurrentTotal() {
                let payload = {freightValue: this.freightValue};
                if (this.getMethod === 'credit-cielo')
                    payload.cardBrand = this.getCardBrand;

                axios.post(this.totalUrl, payload).then((response) => {
                    const data = response.data;

                    this.total = data.total;
                    this.rawTotal = data.raw_total;
                    this.maxParcels = data.max_parcels;
                    this.totalInCash = data.total_in_cash;
                    this.interestRates = data.interest_rates;
                    this.totalInCashFormatted = data.total_in_cash_formatted;

                    this.$root.$emit('updateMaxParcels', this.maxParcels);
                })
            },

            handlePaymentBeforeSubmit() {
                let target = $("input[name='payment_method']:checked").val() === 'boleto' ? '_blank' : '_self';
                const form = $(this.$parent.$refs.paymentForm);
                if (target === '_blank') {
                    form.attr('target', target);
                    form.submit();
                    window.location = '/online/orders';
                } else {
                    form.submit();
                }
                $('.btn-payment-confirmation').attr('disabled', true)
            }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/store/components/TotalPayment.vue